import {
  Loading,
  search,
  useLocalStorage,
  useTranslation,
  useUrlParam,
} from "@opendash/core";
import { Icon } from "@opendash/icons";
import { Button, Flex, Pagination, Timeline } from "antd";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import React, { useEffect, useMemo, useState } from "react";
import { CreateForm } from "..";
import { Message } from "../../../js/parsegenerated";
import { getMessageType } from "../helpers/helpers";
import { CardView } from "./CardView";
import { MessageControl } from "./MessageControl";
import { MessageTitle } from "./MessageTitle";

type Props = {
  messages: Message[];
  loading: boolean;
};

export default observer((props: Props) => {
  const [createOpen, setCreateOpen] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchString] = useUrlParam<string>("search", "");
  const [tableView] = useLocalStorage<"timeline" | "card">(
    "maintenance:machinelog-view",
    "timeline"
  );

  const t = useTranslation();

  useEffect(() => {
    setCurrentPage(1);
  }, [searchString]);

  const filteredData = useMemo(
    () =>
      search(
        searchString === null ? "" : searchString,
        props.messages,
        (msg: Message) => ({
          text: [
            t(msg.get("title"), msg.data?.translation),
            t(msg.get("content"), msg.data?.translation),
          ],
          keys: { types: getMessageType(msg) },
        })
      ),
    [props.messages.length, searchString]
  );

  return (
    <>
      {props.loading ? <Loading message={null} /> : null}
      <Flex
        gap="middle"
        justify="flex-end"
        align="flex-start"
        style={{ marginBottom: 20 }}
      >
        <Button
          icon={<Icon icon="fa:plus" />}
          onClick={() => setCreateOpen(true)}
        >
          {t("maintenance:machinelog.buttons.create")}
        </Button>
      </Flex>

      {tableView === "timeline" && (
        <Timeline
          mode="left"
          items={filteredData
            .slice((currentPage - 1) * 10, (currentPage - 1) * 10 + 10)
            .map((msg) => {
              return {
                label: dayjs(
                  msg?.get("displayAt") ?? msg.get("createdAt")
                ).format("DD.MM.YYYY HH:mm"),
                children: (
                  <Flex
                    gap="middle"
                    justify="flex-start"
                    align="flex-start"
                    vertical
                  >
                    <MessageTitle message={msg} />
                    <MessageControl message={msg} />
                  </Flex>
                ),
              };
            })}
        />
      )}

      {tableView === "card" && (
        <CardView
          messages={filteredData.slice(
            (currentPage - 1) * 10,
            (currentPage - 1) * 10 + 10
          )}
        />
      )}

      <Flex
        gap="middle"
        justify="center"
        align="flex-start"
        style={{ marginTop: 20 }}
      >
        <Pagination
          current={currentPage}
          total={filteredData.length}
          onChange={(page) => setCurrentPage(page)}
        />
      </Flex>

      <CreateForm createOpen={createOpen} setCreateOpen={setCreateOpen} />
    </>
  );
});
